import { IReportItem } from "./reports-Item.model";

export class IReportBase {
    
    reportId: string;
    projectId: string;
    sortedBy: string;
    sortDirection: string;
    status: string;
    searchBy: string;
    searchByValue: string;
    restrictionType: string;
    reportName: string;
    excludeTheseTags: string[];
    includeTheseTags: string[];
    isCustomHeaderSelected:boolean=false;
    customHeader:string;
    asOfDate: string | Date | null;
    selectedIDs:string;
    fromAdvancedSearch: boolean = false;
    fileFormat: string;
    constructor(){
    }
}